document.addEventListener("DOMContentLoaded", function () {

  const reviewsSection = document.querySelector(".reviews-section");
  const sliderElement = reviewsSection.querySelector('.review__items')
  let ifGrid = sliderElement.classList.contains('grid')

  if (reviewsSection) {
    let isMobileView = false;
    let reviewsSlider = null;

    function initSlider() {
      reviewsSlider = new Swiper(".review__items", {
        slidesPerView: 5,
        centeredSlides: true,
        spaceBetween: 32,
        speed: 600,
        loop: false,
        autoHeight: false,
        // initialSlide: ifGrid ? 1 : 2,
        pagination: {
          el: '.slider__pagination',
          clickable: true,
        },
        breakpoints: {
          300: {
            slidesPerView: 1,
            spaceBetween: 15,
            initialSlide: ifGrid ? 0 : 2,
          },
          500: {
            slidesPerView: 1.5,
            spaceBetween: 15,
            initialSlide: ifGrid ? 0 : 2,
          },
          680: {
            slidesPerView: 2,
            spaceBetween: 15,
            initialSlide: ifGrid ? 0 : 2,
          },
          900: {
            slidesPerView: 2.8,
            spaceBetween: 32,
            initialSlide: ifGrid ? 1 : 2,
          },
          1070: {
            slidesPerView: 3,
            spaceBetween: 32,
            initialSlide: ifGrid ? 1 : 2,
          },
        },
      });
    }

    function handleMobileSlider() {
      let isMobile;


      if (ifGrid) {
        isMobile = window.innerWidth <= 1200;
      } else {
        isMobile = true
      }

      if (isMobile && !isMobileView) {
        ifGrid ? isMobileView = true : isMobileView = false

        if (!reviewsSlider) {
          initSlider();
        }
      } else if (!isMobile && isMobileView) {
        ifGrid ? isMobileView = false : isMobileView = true

        if (reviewsSlider) {
          reviewsSlider.destroy();
          reviewsSlider = null;
        }
      }
    }

    handleMobileSlider();
    window.addEventListener("resize", handleMobileSlider);
  }
});